// Centralized API configuration for environment-aware URLs
// In production (behind Apache reverse proxy), all URLs are relative (same origin)
// In development, they point to localhost

const isProduction = process.env.NODE_ENV === 'production';

export const API_BASE_URL = isProduction
  ? '/api'
  : (process.env.REACT_APP_API_URL || 'http://localhost:5010/api');

export const SOCKET_URL = isProduction
  ? '' // Empty string = same origin (Apache proxies /socket.io)
  : (process.env.REACT_APP_SOCKET_URL || 'http://localhost:5010');

export const UPLOADS_URL = isProduction
  ? '/uploads'
  : (process.env.REACT_APP_UPLOADS_URL || 'http://localhost:5010/uploads');